import { axios } from '@/utils/request'
// 获取订单列表
export function getOrderList(params) {
  return axios({
    url: '/distribution/order',
    method: 'GET',
    params
  })
}

// 获取店铺列表
export function getUserStore(params) {
  return axios({
    url: '/distribution/userStore?is_all=1',
    method: 'GET',
    params
  })
}

// 获取订单统计
export function getOrderCount(params) {
  return axios({
    url: '/distribution/order/orderCount',
    method: 'GET',
    params
  })
}

// 获取订单详情
export function getOrderDetail(params) {
  return axios({
    url: '/distribution/order/search?id=' + params.id,
    method: 'GET'
  })
}

// 删除订单
export function deleteOrder(params) {
  return axios({
    url: '/distribution/order/' + params.id,
    method: 'DELETE'
  })
}

// 删除订单
export function hideOrder(params) {
  return axios({
    url: '/distribution/order/hideOrder/' + params.id,
    method: 'GET'
  })
}

// 解析导入文件
export function importOrder(data) {
  return axios({
    url: '/distribution/order/import',
    method: 'POST',
    data: data
  })
}

// 导入订单
export function orderImportRecord(data) {
  return axios({
    url: '/distribution/orderImportRecord',
    method: 'POST',
    data: data
  })
}

// 获取订单项详情
export function getOrderItemDetail(params) {
  return axios({
    url: '/distribution/order/' + params.id,
    method: 'GET',
    params
  })
}

// 修改订单项
export function editOrderItem(data) {
  return axios({
    url: '/distribution/orderItem/' + data.id,
    method: 'PUT',
    data
  })
}

// 复制订单项
export function copyOrderItem(data) {
  return axios({
    url: '/distribution/orderItem/copy',
    method: 'POST',
    data
  })
}

// 删除订单项
export function deleteOrderItem(data) {
  return axios({
    url: '/distribution/orderItem/' + data.id,
    method: 'DELETE',
    data
  })
}

// 获取订单项详情
export function getOrderPay(params) {
  return axios({
    url: '/distribution/orderPay/' + params.id,
    method: 'GET',
    params
  })
}
// 关联产品
export function bindOrderItem(data) {
  return axios({
    url: '/distribution/orderItem/bindOrderItem',
    method: 'POST',
    data
  })
}

// 获取导入订单模板
export function getOrderTemplateInfo() {
  return axios({
    url: '/frontend/getOrderTemplateInfo',
    method: 'GET'
  })
}

// 导出订单
export function exportOrder(data) {
  return axios({
    url: '/distribution/order/export',
    method: 'POST',
    data
  })
}

export function copyItemOrder(data) {
  return axios({
    url: '/distribution/cartItem/adds',
    method: 'POST',
    data
  })
}

export function getOrderLogistics(id) {
  return axios({
    url: '/distribution/orderLogistics/' + id,
    method: 'GET'
  })
}

// 恢复订单
export function resumeOrder(id) {
  return axios({
    url: '/distribution/order/resume/' + id,
    method: 'GET'
  })
}

// 恢复订单
export function getCountry() {
  return axios({
    url: '/api/system/resume/country',
    method: 'GET'
  })
}
// 订单同步
export function syncOrder(data) {
  return axios({
    url: '/distribution/order/syncOrder',
    method: 'POST',
    data
  })
}
// 批量导出发票
export function exportOrderInvoice(data) {
  return axios({
    url: '/distribution/order/exportOrderInvoice',
    method: 'POST',
    data
  })
}
// 批量修改时的物流列表
export function getBatchLogisticsList(params) {
  return axios({
    url: '/distribution/order/batchLogisticsList',
    method: 'GET',
    params
  })
}
// 批量修改物流
export function batchLogisticsSave(data) {
  return axios({
    url: '/distribution/order/batchLogisticsSave',
    method: 'POST',
    data
  })
}
